import { BlurFilter } from '@pixi/filter-blur';
import { TextAnimationConfig } from '../../../../elements/resource/types/shape.type';
import { IncrementController } from '../../../animation/frame/increment/controller/increment.controller';
import { PathElement } from '../primitive/path-element';
import { RectangleElement } from '../primitive/rectangle-element';
import { TextElement } from '../primitive/text-element';
import { TextWord } from './text-word';
import gsap from 'gsap';
import {
  GlowFilter,
  OutlineFilter,
  DropShadowFilter,
  KawaseBlurFilter,
} from 'pixi-filters';

export class TextLetter {
  element: TextElement;
  blurElement: TextElement;
  rect: RectangleElement;
  animationState: {
    start: number;
    end: number;
    division: number;
    current: number;
    state: 'idle' | 'in-progress' | 'finished';
  };
  get cs() {
    return this.textShape.cs;
  }

  get word() {
    return this.parent as TextWord;
  }

  get aboveLetter() {
    return this.word.prevLine?.letters.find(letter =>
      letter.isInMyRegion(this.absoluteX),
    );
  }
  get belowLetter() {
    return this.word.nextLine?.letters.find(letter =>
      letter.isInMyRegion(this.absoluteX),
    );
  }

  get nextLetter() {
    return (this.parent as TextWord).nextLetter(this);
  }

  get firstInLine() {
    return this.config.firstInLine;
  }

  get prevLetter() {
    return (this.parent as TextWord).prevLetter(this);
  }
  get index() {
    return this.config.index;
  }
  get textShape() {
    return this.parent.textShape;
  }
  get char() {
    return this.config.char;
  }
  get height() {
    return this.config.height;
  }
  get style() {
    return this.textShape.elementStyle;
  }
  get x() {
    return this.config.x;
  }

  set x(value: number) {
    this.config.x = value;
    this.element?.patch({
      x: value,
    });
  }
  get absoluteX() {
    return this.x + this.word.xOffset;
  }
  get y() {
    return this.config.y;
  }

  set y(value: number) {
    this.element?.patch({
      y: value,
    });
  }
  get width() {
    if (this.char == '\n') {
      return 0;
    }
    return this.textShape.characterWidthMap[this.char];
  }
  get doInitElement() {
    return this.textShape.elementLevel == 'letter';
  }
  globalIndex: number;
  lefRectangle: RectangleElement;
  rightRectangle: RectangleElement;
  constructor(
    public readonly parent: TextWord,
    private readonly config: {
      char: string;
      x: number;
      y: number;
      height: number;
      index: number;
      firstInLine?: boolean;
    },
  ) {
    this.globalIndex = this.textShape.getLetterIndex();
    // -- // -- // -- // -- //

    // this.blurElement = new TextElement(
    //   this.parent.textShape,
    //   this.parent.container,
    //   {
    //     ...(this.style as any),
    //     text: this.config.char,
    //     x: this.config.x,
    //     y: this.config.y,
    //     fontSize: this.textShape.fontSize * 1.1,
    //     fill: '#C5A3FF',
    //   },
    // );

    // -- //
    // const bounds = this.blurElement.element.getBounds();

    if (this.doInitElement) {
      const blurFilter = new KawaseBlurFilter();
      blurFilter.blur = 8;

      // const outlineFilter = new OutlineFilter(15, 2, 0xffffff);
      this.element = new TextElement(
        this.parent.textShape,
        this.parent.container,
        {
          ...(this.style as any),
          text: this.config.char,
          // text: '',
          x: this.config.x,
          y: this.config.y,
          log: this.config.char == 'r',
          // dropShadowBlur: 6,
          // dropShadowColor: '#000000',
          // dropShadowAlpha: 0.4,
          // dropShadowDistance: 4,
          // fill: gradient,
        },
      );
      // this.element._element.filters = [blurFilter];
    }

    // -- //
    // const bounds2 = this.element.element.getBounds();

    // this.blurElement.patch({
    //   x: this.config.x - (bounds.width - bounds2.width),
    //   y: this.config.y - (bounds.height - bounds2.height) / 2,
    // });
    // this.blurElement.element.filters = [new BlurFilter(1)];

    // if (this.textShape._isRoot) {
    this.element
      ?.click(() => this.textShape.clicked())
      .doubleclick(coords => {
        // console.log('double-click', coords);
        // const [xa, ya] = coords;
        // console.log('x', xa - this.x, 'y', ya - this.y); //
        // const [x, y] = [xa - this.x, ya - this.y]; // -- //
        if (!this.textShape.selected) {
          this.textShape.select();
        }
        // this.wordWrap = false;   // -- // -- // -- //
        // this.wordWrapWidth = Infinity; // -- // -- //
        this.textShape.selectedEditMode = true; // -- //
      })
      .mouseover(() => {
        if (this.textShape.selected) {
          return;
        }
        this.textShape.select({ onHover: true });
      })
      .mouseout(() => {
        if (this.textShape.selected) {
          return;
        }
        this.textShape.deselect({ onHover: true });
      })
      .drag(
        (dx, dy) => {
          this.textShape.service.drag(dx, dy);
        },
        () => this.textShape.localStartDrag(),
        () => {
          // console.log('ps.element > endDrag');
          this.textShape.service.endDrag();
        },
      );

    // this.element.hidden = true;
    if (this.width) {
      this.lefRectangle = new RectangleElement(
        this.parent.textShape,
        this.parent.container,
        {
          position: {
            x: this.config.x,
            y: this.config.y,
          },
          width: this.width / 2,

          height: this.config.height,
          fill: '#000000',
          opacity: 0.001,
        },
      ).click(() => {
        this.leftClick();
      });

      this.lefRectangle?.hide();

      this.rightRectangle = new RectangleElement(
        this.parent.textShape,
        this.parent.container,
        {
          position: {
            x: this.config.x + this.width / 2,
            y: this.config.y,
          },
          width: this.width / 2,
          height: this.config.height,
          fill: '#000000',
          opacity: 0.001,
        },
      ).click(() => {
        this.rigthClick();
      });

      this.rightRectangle?.hide();
    }

    // this.rect = new RectangleElement(
    //   this.parent.textShape,
    //   this.parent.container,
    //   {
    //     position: {
    //       x: this.config.x,
    //       y: this.config.y,
    //     },
    //     width: this.width,
    //     height: this.config.height,
    //     fill: '#000000',
    //     opacity: 0.001,
    //     stroke: '#000000',
    //     'stroke-width': 1,
    //   },
    // )
    //   .click(coords => {
    //     if (!this.textShape.selected) {
    //       return;
    //     }

    //     if (this.parent.wholeTextSelectionBlock250ms) {
    //       return;
    //     }

    //     if (this.parent.doubleClickTookPlace) {
    //       this.parent.wholeTextSelectionBlock250ms = true;
    //       setTimeout(
    //         () => (this.parent.wholeTextSelectionBlock250ms = false),
    //         250,
    //       );
    //       return this.textShape.selectWholeText();
    //     }

    //     const [x] = coords;
    //     if (2 * (x - this.textShape.x - this.config.x) < this.width) {
    //       // console.log('left');
    //       this.parent.showCursorByIndex(this.config.index);
    //     } else {
    //       // console.log('right');
    //       this.parent.showCursorByIndex(this.config.index + 1);
    //     }
    //   })
    //   .doubleclick(() => {
    //     if (!this.textShape.selected) {
    //       return;
    //     }
    //     // console.log('tw > double-click'); //

    //     if (this.parent.wholeTextSelectionBlock250ms) {
    //       return;
    //     }
    //     // -- // -- // -- // -- //
    //     // this sets the last cursor
    //     this.parent.selectWord();
    //     this.parent.doubleClickTookPlace = true;
    //     setTimeout(() => {
    //       this.parent.doubleClickTookPlace = false;
    //       // console.log('------- dobuleClick-setTimeout -----'); //
    //     }, 1_000);
    //   })
    //   .mouseover(() => {
    //     // console.log('mouse-over');
    //     this.parent.textShape.select({ onHover: true });
    //   })
    //   .mouseout(() => {
    //     // console.log('mouse-out');
    //     this.parent.textShape.deselect({ onHover: true });
    //   })
    //   .drag(
    //     (dx, dy) => {
    //       this.textShape.service.drag(dx, dy);
    //     },
    //     () => this.textShape.localStartDrag(),
    //     () => {
    //       // console.log('ps.element > endDrag');
    //       this.textShape.service.endDrag();
    //     },
    //   );
    // this.rect?.hide();
    // }
  }

  initElement() {
    this.element = new TextElement(
      this.parent.textShape,
      this.parent.container,
      {
        ...(this.style as any),
        text: this.config.char,
        // text: '',
        x: this.config.x,
        y: this.config.y,
        log: this.config.char == 'r',
        // fill: gradient,
      },
      0,
    );
  }
  disablePointerEvents() {
    this.element?.setEventMode('none');
  }
  enablePointerEvents() {
    this.element?.setEventMode('dynamic');
  }
  showRectangles() {
    this.lefRectangle?.show();
    this.rightRectangle?.show();
  }

  hideRectangles() {
    this.lefRectangle?.hide();
    this.rightRectangle?.hide();
  }

  select() {
    console.log('text-letter-select', {
      globalIndex: this.globalIndex,
      currentSelectionIndex: this.textShape.currentSelectionIndex,
      selectionStartIndex: this.textShape.selectionStartIndex,
    });
    // console.log('text-select', this.textShape.cs.isShiftPressed);
    if (this.textShape.cs.isShiftPressed) {
      this.textShape.currentSelectionIndex = this.globalIndex;
    } else {
      this.textShape.selectionStartIndex = this.globalIndex;
      this.textShape.currentSelectionIndex = this.globalIndex;
    }
    this.textShape.updateSelection();
    this.showCursor();
  }

  animateGradient(duration: number) {
    const object = { start: -1, center: -0.5, end: 0 };
    const timeLine = gsap.to(object, {
      duration,
      start: 1,
      center: 1.5,
      end: 2,
      ease: 'none',
      onStart: () => {
        this.element._element.style = {
          ...this.element._element.style,
          fill: ['#ffffff', '#ffffff', '#723580ff', '#fff', '#fff'],
          fillGradientStops: [0, 0, 0, 0, 1],
          fillGradientType: 1,
        };
        //this.element._element.style.fillGradientStops = [0, 0.1, 1];
      },
      onUpdate: () => {
        // console.log('on-update', this.progress());
        // this.bgService.render();
        const { start, center, end } = object;
        const norm = (val: number) => {
          if (val < 0) {
            return 0;
          }
          if (val > 1) {
            return 1;
          }
          return val;
        };
        this.element._element.style.fillGradientStops = [
          0,
          norm(start),
          norm(center),
          norm(end),
          1,
        ];
      },
    });
    return gsap.timeline().add(timeLine);
  }

  updateSelection(start: number, end: number) {
    // -- // -- // -- //
    if (start <= this.globalIndex && this.globalIndex < end) {
      // console.log('-------------- ');
      this.lefRectangle?.patch({
        opacity: 0.25,
      });
      this.rightRectangle?.patch({
        opacity: 0.25,
      });
      return;
    }
    this.clearSelection();
  }

  clearSelection() {
    this.lefRectangle?.patch({
      opacity: 0.001,
    });
    this.rightRectangle?.patch({
      opacity: 0.001,
    });
  }

  arrowRight() {
    if (!this.cs.isShiftPressed && this.textShape.multipleLettersSelected) {
      const [start, end] = [
        this.textShape.selectionStartIndex,
        this.textShape.currentSelectionIndex,
      ].sort((a, b) => a - b);
      this.textShape.selectionStartIndex = end;
      this.textShape.currentSelectionIndex = end;

      this.textShape.currentLetter?.showCursor();
      this.textShape.updateSelection();
      return;
    }
    // if (this.nextLetter) {
    this.nextLetter?.select();
    // } else {
    //   if (!this.parent.cs.isShiftPressed) {
    //     this.textShape.selectionStartIndex = this.globalIndex;
    //     this.textShape.currentSelectionIndex = this.globalIndex;
    //     this.showCursor();
    //     this.textShape.updateSelection();
    //   }
    // }
  }

  arrowLeft() {
    console.log(
      'arrowLeft',
      this.cs.isShiftPressed,
      'arrowRight',
      this.textShape.multipleLettersSelected,
    );
    if (!this.cs.isShiftPressed && this.textShape.multipleLettersSelected) {
      const [start, end] = [
        this.textShape.selectionStartIndex,
        this.textShape.currentSelectionIndex,
      ].sort((a, b) => a - b);

      this.textShape.selectionStartIndex = start;
      this.textShape.currentSelectionIndex = start;
      // this.showCursor();
      this.textShape.currentLetter?.showCursor();
      this.textShape.updateSelection();
      return;
    }
    return this.prevLetter?.select();
    if (this.prevLetter) {
      this.prevLetter.select();
    } else {
      if (!this.parent.cs.isShiftPressed) {
        this.textShape.selectionStartIndex = this.globalIndex;
        this.textShape.currentSelectionIndex = this.globalIndex;
        this.showCursor();
        this.textShape.updateSelection();
      }
    }
  }

  arrowUp() {
    this.aboveLetter?.select();
  }
  arrowDown() {
    this.belowLetter?.select();
  }

  leftClick() {
    this.select();
  }
  rigthClick() {
    this.nextLetter?.select();
  }

  cursorElement: PathElement;
  hideCursor() {
    this.cursorElement?.remove();
  }
  showCursor() {
    // -- // -- // -- // -- // -- //
    this.textShape.letterClicked(this);
    this.cursorElement = new PathElement(
      this.textShape,
      this.parent.container,
      {
        position: {
          x: this.x,
          y: this.y,
        },
        elements: [
          {
            type: 'line',
            x: 0,
            y: this.height,
          },
        ],
        stroke: '#000000',
        'stroke-width': 1,
      },
    );
  }

  floatIncrementController: IncrementController;
  opacityIncrementController: IncrementController;

  startAnimation(
    { start, end }: { start: number; end: number },
    config?: TextAnimationConfig,
  ) {
    // -- // -- //
    const division = end - start;
    this.animationState = {
      start,
      end,
      division,
      current: 0,
      state: 'idle',
    };

    this.floatIncrementController = new IncrementController(
      // this.textShape.netLineHeight / 2,
      this.textShape.netLineHeight,
      0,
      division,
    );
    this.opacityIncrementController = new IncrementController(0, 1, division);

    this.element.patch({
      y: this.y + this.textShape.netLineHeight / 2,
      opacity: 0,
    });

    // console.log('startAnimation', this.char, 'y', this.y);
    // -- // -- // -- //
  }

  setMask(mask: RectangleElement) {
    this.element.setMask(mask.element);
  }

  removeMask() {
    this.element.setMask(null);
  }

  incrementAnimation(increment: number) {
    if (!this.animationState) {
      return true;
    }
    this.animationState.current += increment;
    const { current, start, end, state } = this.animationState;

    if (state == 'finished') {
      return true;
    }
    // -- //

    if (current < start) {
      return;
    }

    if (end < current && state == 'in-progress') {
      return this.endAnimation();
    }

    this.animationState.state = 'in-progress';
    const dy = this.floatIncrementController.increment(increment);
    const dOpacity = this.opacityIncrementController.increment(increment);

    this.element.patch({
      y: this.y + dy,
      opacity: dOpacity,
    });
  }

  isInMyRegion(x: number) {
    if (this.char == '\n') {
      return this.absoluteX <= x;
    }

    if (this.config.firstInLine) {
      return x < this.absoluteX + this.width / 2;
    }

    return (
      this.absoluteX - this.width / 2 <= x &&
      x < this.absoluteX + this.width / 2
    );
  }

  endAnimation() {
    if (!this.animationState) {
      return;
    }
    this.animationState.state = 'finished';
    this.element.patch({
      y: this.y,
      opacity: this.opacityIncrementController.end,
      position: {
        x: this.x,
        y: this.y,
      },
    });

    return true;
  }

  show() {
    this.rect?.show();
    this.element?.show();
  }

  hide() {
    this.element?.hide();
    this.rect?.hide();
  }

  patch() {
    // -- // -- // -- //
  }

  remove() {
    this.blurElement?.remove();
    this.element?.remove();
    this.rect?.remove();
    this.cursorElement?.remove();
    this.lefRectangle?.remove();
    this.rightRectangle?.remove();
  }
}
